module.exports = __webpack_public_path__ + "static/media/lease6_img2.82426dca.jpg";